module.exports = __webpack_public_path__ + "img/step43_down.8ea9ebf0.png";